// ISO2 country code to country name mapping
// Common countries that are likely to be supported by gift card providers
export const COUNTRY_CODE_TO_NAME = {
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  AU: 'Australia',
  DE: 'Germany',
  FR: 'France',
  IT: 'Italy',
  ES: 'Spain',
  NL: 'Netherlands',
  BE: 'Belgium',
  AT: 'Austria',
  CH: 'Switzerland',
  SE: 'Sweden',
  NO: 'Norway',
  DK: 'Denmark',
  FI: 'Finland',
  IE: 'Ireland',
  PT: 'Portugal',
  PL: 'Poland',
  GR: 'Greece',
  CZ: 'Czech Republic',
  HU: 'Hungary',
  RO: 'Romania',
  BG: 'Bulgaria',
  HR: 'Croatia',
  SK: 'Slovakia',
  SI: 'Slovenia',
  EE: 'Estonia',
  LV: 'Latvia',
  LT: 'Lithuania',
  JP: 'Japan',
  KR: 'South Korea',
  CN: 'China',
  IN: 'India',
  SG: 'Singapore',
  MY: 'Malaysia',
  TH: 'Thailand',
  ID: 'Indonesia',
  PH: 'Philippines',
  VN: 'Vietnam',
  NZ: 'New Zealand',
  BR: 'Brazil',
  MX: 'Mexico',
  AR: 'Argentina',
  CL: 'Chile',
  CO: 'Colombia',
  PE: 'Peru',
  ZA: 'South Africa',
  AE: 'United Arab Emirates',
  SA: 'Saudi Arabia',
  IL: 'Israel',
  TR: 'Turkey',
  RU: 'Russia',
  UA: 'Ukraine',
};

// Country name to ISO2 code mapping (reverse lookup)
export const COUNTRY_NAME_TO_CODE = Object.fromEntries(
  Object.entries(COUNTRY_CODE_TO_NAME).map(([code, name]) => [name, code])
);

// Get country name from ISO2 code
export const getCountryName = (code) => {
  return COUNTRY_CODE_TO_NAME[code?.toUpperCase()] || code;
};

// Get ISO2 code from country name
export const getCountryCode = (name) => {
  return COUNTRY_NAME_TO_CODE[name] || null;
};

// Convert ISO2 country code to flag emoji
// Uses Unicode regional indicator symbols (A = U+1F1E6, etc.)
export const getCountryFlag = (code) => {
  if (!code || code.length !== 2) return '';
  const codePoints = code
    .toUpperCase()
    .split('')
    .map((char) => 0x1f1e6 + (char.charCodeAt(0) - 65));
  return String.fromCodePoint(...codePoints);
};

// Get list of countries as options for selectors (sorted by name)
export const getCountryOptions = () => {
  return Object.entries(COUNTRY_CODE_TO_NAME)
    .map(([code, name]) => ({
      value: code,
      label: `${getCountryFlag(code)} ${name}`,
      flag: getCountryFlag(code),
      countryName: name,
    }))
    .sort((a, b) => a.countryName.localeCompare(b.countryName));
};
